import packageConfig from '../utils/packageConfig.json';

const dollarize = num => (
  num ? `$${parseFloat(num).toFixed(2)}` : '$0.00'
);

export const dollarizeNoDecimal = num => (
  num ? `$${parseFloat(num).toFixed(0)}` : '$0'
);

export const numberWithCommas = x => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const formatIpString = num => `${num} additional IP${num !== 1 ? 's' : ' '}`;

export const formatEaseString = num => `${num} days of Email Activity History`;

export const formatEaseOptionString = num => `${num} days of History`;

export function isPackageFree(selectedPackage) {
  if (selectedPackage in packageConfig.freePackages) {
    return true;
  }

  return false;
}

export function isPackageAds(selectedPackage) {
  if (selectedPackage in packageConfig.adsPackages) {
    return true;
  }

  return false;
}

export function isPackagePro(selectedPackage) {
  if (selectedPackage in packageConfig.proPackages) {
    return true;
  }
  return false;
}

export const calculateEstimatedEmailPrice = (num, pkg) => {
  const overageRate = packageConfig.overage_rates[pkg.name] ?
    packageConfig.overage_rates[pkg.name] :
    pkg.overage_price;

  const price = (num - pkg.credits) * overageRate;
  return price > 0 ? price : 0.00;
};

export const calculateEstimatedContactsPrice = (num) => {
  if (num <= 2000) {
    return 0;
  }

  return Math.ceil(num / 10000) * 10;
};

// calculate package price based on date of the month
export const calculateEstimatedProratedPrice = (price) => {
  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  const currentYear = currentDate.getYear();
  const currentMonth = currentDate.getMonth();
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const remainingMonth = (daysInMonth - currentDay + 1) / daysInMonth;
  // the percentage of month left times the price
  return remainingMonth * price;
};

export const calculateEasePrice = (days, pkg) => {
  if (days === 3) {
    return 0;
  } else if (days === 30) {
    switch (pkg) {
      case 'Essentials 40K':
        return 5;
      case 'Essentials 100K':
        return 12;
      case 'Pro 100K':
        return 12;
      case 'Pro 300K':
        return 40;
      case 'Pro 700K':
        return 95;
      case 'Pro 1.5 Million':
        return 175;
      default:
        return 0;
    }
  }
  return 0;
};
export default dollarize;



// WEBPACK FOOTER //
// ./src/utils/displayHelpers.js